declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackCartProductProtectionUserUnSelected = data => {
  const event = 'cart_product_protection_user_unselected'

  const logData = {
    event,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackCartProductProtectionUserUnSelected
